import { cva } from 'class-variance-authority';
import { HTMLAttributes, JSX } from 'react';
import { cn } from '@/lib/utils';

const textVariants = cva('text-texts-default uppercase', {
  variants: {
    level: {
      1: 'font-eurostile text-2xl font-black leading-tight tracking-4',
      2: 'font-eurostile text-xl font-black leading-tight tracking-3',
      3: 'font-eurostile text-lg font-extrabold leading-tight tracking-3',
      4: 'font-eurostile text-base font-extrabold leading-tight tracking-2',
      5: 'font-eurostile text-sm font-bold leading-normal tracking-3',
      6: 'font-eurostile text-xs font-bold leading-normal tracking-2',
    },
  },
});

interface TitleProps extends HTMLAttributes<HTMLElement> {
  level: 1 | 2 | 3 | 4 | 5 | 6;
}

export const Title = ({
  children,
  level,
  className,
}: TitleProps): JSX.Element => {
  const Comp: keyof JSX.IntrinsicElements = `h${level}`;

  return (
    <Comp className={cn(textVariants({ level }), className)}>{children}</Comp>
  );
};
